<template>
    <div class="popup">
         <el-tabs v-model="activeName" type="card" v-if="fields">
             <!-- {{fields}} -->
            <el-tab-pane :label="fname" :name="fname" v-for="(fvalue,fname,index) in fields" :key="index">
                <ul>
                    <li v-for="(svalue,sname,sindex) in fvalue" :key="sindex" class="label-item">
                        <div v-if=" (typeof svalue !== 'object') ">                        
                            <span>{{sname}}：</span>
                            <span>{{svalue}}</span>
                        </div>
                        <div v-else>
                            <!--数组的展示-->
                            <div v-if="(svalue instanceof Array)">
                                <div style="text-align: center;border-left: 1px solid;border-right: 1px solid;">{{sname}}</div>
                                <table border="1" bordercolor="#fff" width="100%" cellspacing="0" cellpadding="5" v-for="(fovalue,foindex) of svalue" :key="foindex">
                                    <tr>
                                        <td v-for="(fivalue,finame,fiindex) in fovalue" :key="fiindex">{{finame}}</td>
                                    </tr>
                                    <tr>
                                        <td v-for="(fivalue,finame,fiindex) in fovalue" :key="fiindex">{{fivalue}}</td>
                                    </tr>
                                </table>
                            </div>
                            <!--对象的展示-->
                            <table border="1" bordercolor="#fff" width="100%" cellspacing="0" cellpadding="5" v-else>
                                <tr>
                                    <td :colspan="Object.keys(svalue).length">{{sname}}</td>
                                </tr>
                                <tr>
                                    <td v-for="(tvalue,tname,tindex) in svalue" :key="tindex">{{tname}}</td>
                                </tr>
                                <tr>
                                    <td v-for="(tvalue,tname,tindex) in svalue" :key="tindex">{{tvalue}}</td>
                                </tr>
                            </table>
                        </div>
                    </li>
                </ul>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name:"Popup",
    props:['popupinfo'],
    data(){
        return {
            activeName:"first" , // 打开的属性框 
        }
    },
    computed:{
        fields(){
            let tempFields=this.popupinfo&&this.popupinfo.fields?JSON.parse(this.popupinfo.fields):"";
            return tempFields;
        }
    },
    watch:{
        fields(newValue){
            if(newValue){
                this.activeName=Object.keys(newValue)[0];
            }
        }
    }
}
</script>

<style lang="scss">
.popup{
    display: none;

    table{
        td {
        
            text-align:center;
        
        }
    }

}
</style>